export default "__VITE_ASSET__D1zdyDW5__"